import {createGloballyExclusiveHandler} from '../../../../../../shared/scripts/ui_utils/ClientUtils'
import {uiManager} from '../../../../EntryMobile'
import {Sound} from '../../../../../../shared/scripts/Sound'
import {ViewPopupInput} from '../../../../../../shared/scripts/ui_popup/ViewPopupInput'
import {UILobbyController} from '../../../../../../shared/scripts/ui_html/lobby/UILobbyController'
import {RoomStep} from '../../../room/UIMCreateRoomController'
import {SocketLobbySend} from '../../../../../../shared/scripts/socket/SocketLobbySend'
import {ClientUserState} from '../../../../../../shared/scripts/ClientUserState.ts'

export class UIMLobbyController extends UILobbyController {
    private readonly createRoomButton: HTMLDivElement
    private readonly joinRoomButton: HTMLDivElement

    constructor() {
        super()
        this.createRoomButton = document.getElementById('m-lobby-create-room-btn') as HTMLDivElement
        this.joinRoomButton = document.getElementById('m-lobby-join-room-btn') as HTMLDivElement

        this.createRoomButton.onclick = createGloballyExclusiveHandler(async() => {
            Sound.playSound(Sound.SoundType.JoinRoom)

            await ClientUserState.requireUser()

            uiManager.createRoomController.initCreateRoomView()
        })

        this.joinRoomButton.onclick = createGloballyExclusiveHandler(() => {
            const popup = new ViewPopupInput({key: 'strings:homePage.lobbyPage.popups.enterRoomID.title'}, {key: 'strings:homePage.lobbyPage.popups.enterRoomID.body'}, async(roomId: string) => await UIMLobbyController.handleJoinRoom(roomId.trim().toLocaleLowerCase()), () => undefined, true)
            popup.setLengthLimits(1, 10)
            popup.show()
        })
    }

    private static async handleJoinRoom(roomId: string) {
        uiManager.createRoomController.setShowPageOnNextUpdate(RoomStep.RoomPage)
        await SocketLobbySend.accessGameFromLink(roomId)
    }
}
